import axios from 'axios';
import Config from '../Helpers/Config';
import {locale} from '../locale/AppLocale';
import {push as routerPush} from 'react-router-redux'
import {NotificationManager} from '../Helpers/NotificationManager';

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;

// ℹ️ Add request interceptor to send the authorization header on each subsequent request after login
axios.interceptors.request.use(config => {
    // Retrieve token from localStorage
    const token = localStorage.getItem('auth_token')
    // If token is found
    config.headers = config.headers || {}

    if (token && token.length && !config.headers.Authorization) {
        config.headers.Authorization = token ? `Bearer ${token}` : ''
    }

    return config
})

export const selectBusiness = (business) => {

    localStorage.setItem('default_business', business.id)
    return {
        type: 'SELECT_DEFAULT_BUSINESS',
        business:business
    }
};



const dispatchAuthPopups = (dispatch,data) => {
    let mobileUpdateStatus = false;
    let mobileConfirmStatus = false;
    let emailConfirmStatus = false;

    if(!data.user.mobile){
        mobileUpdateStatus = true;
    }else if(data.user.confirmed_mobile !== true){
        mobileConfirmStatus = true
    }else if(data.user.confirmed_email !== true){
        emailConfirmStatus = true
    }


    dispatch({
        type: 'UI_REQUIRE_MOBILE_UPDATE',
        status:mobileUpdateStatus
    });


    dispatch({
        type: 'UI_REQUIRE_MOBILE_CONFIRM',
        status:mobileConfirmStatus
    });

    dispatch({
        type: 'UI_REQUIRE_EMAIL_CONFIRM',
        status:emailConfirmStatus
    });

}


export const requiresRelogin = (status = true,requiresReload = false) => ({
    type: 'AUTH_REQUIRES_RELOGIN',
    payload:{
        status:status,
        relogin_reload:requiresReload
    }
})


export const check = (showNotification = true) => {
    return function (dispatch,getState) {
        dispatch({
            type: 'FETCHING_AUTH'
        });
        return axios.get(Config.accountsApi() + 'auth/check', {
            withCredentials: true,
        })
            .then((response) => {
               if(response.data.code !== 400){
                   if(response.data.user.confirmed_email && response.data.user.confirmed_mobile){
                       response.data.can_request = true;
                   }else{
                       response.data.can_request = false;
                   }
               }

                dispatch({
                    type: 'AUTH_FETCHED_LOGIN',
                    results: response.data
                });
                const selectedBusinessId = localStorage.getItem('default_business');
                let selectedBusiness = response.data.business;
                if (selectedBusinessId && response.data.businesses.length){
                    selectedBusiness = response.data.businesses.filter(businesse => parseInt(businesse.id,10) === parseInt(selectedBusinessId,10))[0];
                }

                if (selectedBusiness){
                    response.data.business = selectedBusiness;

                    dispatch(selectBusiness(selectedBusiness));

                }

                dispatchAuthPopups(dispatch,response.data);
            })
            .catch((error) => {
                if(showNotification){
                    NotificationManager.error(locale.get('an_error_occurred_while_check_login'));
                }
            })
    };
};

export const login = (params,callback =()=>{},redirect = true) => {
    return function (dispatch,getState) {
        const state = getState();
        dispatch({
            type: 'AUTH_FETCHING'
        });
        const data = {email: params.email, password: params.password, remember: params.remember};
        return axios.post(Config.accountsApi() + 'auth/login', data, {withCredentials: true})
            .then((response) => {

                if(response.data.status === true){

                    if(state.auth.business.id){
                        response.data.business = response.data.businesses.reduce((matchedBusiness,business) => {
                            if(state.auth.business.id === business.id ){
                                matchedBusiness = business;
                            }
                            return matchedBusiness
                        },{})
                    }
                    dispatch({
                        type: 'AUTH_FETCHED_LOGIN',
                        results: response.data
                    });
                    if(redirect){
                        dispatch(routerPush(`/${response.data.business.slug}/orders`));
                    }
                    callback(response.data);
                }else{
                    NotificationManager.error(locale.get('login_failed'));
                }
            })
            .catch((error) => {
                console.error('error',error)
                NotificationManager.error(locale.get('login_failed'));
                dispatch({
                    type: 'AUTH_LOGIN_FAILED',
                    results: {}
                });
            });
    };
};

export const loginByHash = (params) => {
    return function (dispatch) {
        dispatch({
            type: 'AUTH_FETCHING'
        });
        const data = {email: params.email, password: params.password, remember: params.remember};
        return axios.post(Config.accountsApi() + 'auth/hash-login', data, {withCredentials: true});
    };
};

export const logout = () => {
    return function (dispatch) {
        dispatch({
            type: 'FETCHING_AUTH'
        });
        localStorage.setItem('auth_token',null)

        return axios.post(Config.accountsApi() + 'auth/logout',{},{withCredentials: true})
            .then((response) => {
                dispatch({
                    type: 'AUTH_LOGGED_OUT',
                    results: response.data
                });

                NotificationManager.success(locale.get('logout_success'));
            }).catch((error) => {
                dispatch({
                    type: 'FETCHING_AUTH_FAILED'
                });
            });
    };
};
